import { CALL_API } from '../../../middlewares/api';

import { updateInfos } from '../../account/actions';

import { REQUEST_REGISTER, SUCCESS_REGISTER, FAILURE_REGISTER } from './constants';

export const registerUser = (form, callback) => {
    return {
        [CALL_API]: {
            endpoint: '/auth/register',
            types: [REQUEST_REGISTER, SUCCESS_REGISTER, FAILURE_REGISTER],
            body: form,
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                if (callback) {
                    callback();
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/register/actions.js